import { Flex, Image, Text } from "@chakra-ui/react";
import React from "react";
import { MdCall } from "react-icons/md";
import { Header } from "./styles";
// Place company brand

const Brand: React.FC = () => {
    return (
        <Flex
            height="50px"
            alignContent="center"
            alignItems="center"
            paddingRight="140px"
        >
            <Header>
                <Image src="/logo-transparent.png" />
            </Header>
        </Flex>
    );
};

export default Brand;
